import { CommonEnums } from '../../common.enums';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { TransposeInst } from './transposeInst';
import { Attribute } from './attribute';
import { AttributesUtil } from 'src/app/shared/grids/attributes/attributes.util';
import { Obj_Db_PropertiesUtil } from '../../utils/obj_db_properties.util';
import { Db_PropertyTypesUtil } from '../../utils/db_propertytypes.util';
export class Transpose {
    transposeInst: TransposeInst;
    attributes: Array<Attribute>;

    nativeDbTyp_Id: number; //Read-only
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string; //Read-Only
    fldr_Id: number;
    is_In_SubFlow: string;
    sel_Run_PropertyType_Cd: string;
    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;
    gen_Tab_Change_Ind: string; //Read-Only
    attr_Tab_Change_Ind: string; //Read-Only
    rProp_Tab_Change_Ind: string; //Read-Only
    prop_Tab_Change_Ind: string;


    constructor() {
        this.setDefaults()
    }

    setDefaults() {
        this.transposeInst = new TransposeInst();
        this.attributes = new Array<Attribute>();
        this.nativeDbTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.change_Ind = CommonEnums.defaults.CHANGE_IND_NO;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.is_In_SubFlow = CommonEnums.defaults.STRING_EMPTY;
        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.run_Properties = new Array<Obj_Db_Property>();
        this.runPropertyTypes = new Array<Db_PropertyType>();
        this.gen_Tab_Change_Ind = CommonEnums.defaults.CHANGE_IND_NO; //Read-Only
        this.attr_Tab_Change_Ind = CommonEnums.defaults.CHANGE_IND_NO; //Read-Only
        this.rProp_Tab_Change_Ind = CommonEnums.defaults.CHANGE_IND_NO; //Read-Only
        this.prop_Tab_Change_Ind = CommonEnums.defaults.CHANGE_IND_NO;
    }

    static parse(transposeTmp: Transpose): Transpose {
        let transpose: Transpose = new Transpose();
        transpose.copyFrom(transposeTmp);
        return transpose;
    }

    copy(): Transpose {
        let transposeTmp: Transpose = new Transpose();
        transposeTmp.transposeInst = this.transposeInst.copy();
        transposeTmp.attributes = AttributesUtil.getInstance().copy(this.attributes);
        transposeTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        transposeTmp.change_Ind = this.change_Ind;
        transposeTmp.error_Cd = this.error_Cd;
        transposeTmp.error_Msg = this.error_Msg;
        transposeTmp.ref_Id = this.ref_Id;
        transposeTmp.ref_Cd = this.ref_Cd;
        transposeTmp.fldr_Id = this.fldr_Id;
        transposeTmp.is_In_SubFlow = this.is_In_SubFlow;
        transposeTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;
        transposeTmp.run_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.run_Properties);
        transposeTmp.runPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.runPropertyTypes);

        transposeTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
        transposeTmp.attr_Tab_Change_Ind = this.attr_Tab_Change_Ind;
        transposeTmp.rProp_Tab_Change_Ind = this.rProp_Tab_Change_Ind;
        transposeTmp.prop_Tab_Change_Ind = this.prop_Tab_Change_Ind;

        return transposeTmp;
    }

    copyFrom(transposeTmp: Transpose): void {
        this.transposeInst.copyFrom(transposeTmp.transposeInst);

        AttributesUtil.getInstance().copyFrom(this.attributes, transposeTmp.attributes);
        this.nativeDbTyp_Id = transposeTmp.nativeDbTyp_Id;
        this.change_Ind = transposeTmp.change_Ind;
        this.error_Cd = transposeTmp.error_Cd;
        this.error_Msg = transposeTmp.error_Msg;
        this.ref_Id = transposeTmp.ref_Id;
        this.ref_Cd = transposeTmp.ref_Cd;
        this.fldr_Id = transposeTmp.fldr_Id;
        this.is_In_SubFlow = transposeTmp.is_In_SubFlow;
        this.sel_Run_PropertyType_Cd = transposeTmp.sel_Run_PropertyType_Cd;
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.run_Properties, transposeTmp.run_Properties);
        Db_PropertyTypesUtil.getInstance().copyFrom(this.runPropertyTypes, transposeTmp.runPropertyTypes);

        this.gen_Tab_Change_Ind = transposeTmp.gen_Tab_Change_Ind;
        this.attr_Tab_Change_Ind = transposeTmp.attr_Tab_Change_Ind;
        this.rProp_Tab_Change_Ind = transposeTmp.rProp_Tab_Change_Ind;
        this.prop_Tab_Change_Ind = transposeTmp.prop_Tab_Change_Ind;
    }

    compare(transposeTmp: Transpose): string {
        let transposestring: string = this.toString();
        let transposeTmpstring: string = transposeTmp.toString();

        if (transposestring != transposeTmpstring) {
            return transposestring + ', ' + transposeTmpstring;
        }

        return '';
    }

    toString(): string {
        return "Transpose[ transposeInst=" + this.transposeInst.toString() +
            ", attributes=" + AttributesUtil.getInstance().toString(this.attributes) +
            ", nativeDbTyp_Id=" + this.nativeDbTyp_Id +
            ", change_Ind=" + this.change_Ind +
            ", error_Cd=" + this.error_Cd +
            ", error_Msg=" + this.error_Msg +
            ", ref_Id=" + this.ref_Id +
            ", ref_Cd =" + this.ref_Cd +
            ", fldr_Id=" + this.fldr_Id +
            ", is_In_SubFlow=" + this.is_In_SubFlow +
            ", sel_Run_PropertyType_Cd=" + this.sel_Run_PropertyType_Cd +
            ", run_Properties =" + Obj_Db_PropertiesUtil.getInstance().toString(this.run_Properties) +
            ", runPropertyTypes=" + Db_PropertyTypesUtil.getInstance().toString(this.runPropertyTypes) +
            ", gen_Tab_Change_Ind=" + this.gen_Tab_Change_Ind +
            ", attr_Tab_Change_Ind =" + this.attr_Tab_Change_Ind +
            ", rProp_Tab_Change_Ind=" + this.rProp_Tab_Change_Ind +
            ", prop_Tab_Change_Ind=" + this.prop_Tab_Change_Ind + "]";
    }
}